namespace Matrix.Workflow {
    export class WorkflowColumns {
        static columnsKey = 'Workflow.Workflow';
    }
}
